import { DigitalGpSubmission } from '@sky-distribution/digital-gp-submission';
import { ProducerDataTrackingCodes } from './trackingCodes';

const DEFAULT_SALES_CHANNEL = 'web';
const SECOND_UTM_AFFILIATE_LINK_VERSION = '2';

export const getDigitalSubmissionWithProducerData = (
  submission: DigitalGpSubmission,
  { utmAffLinkVersion, employeeId, salesChannel }: ProducerDataTrackingCodes | undefined = {},
): DigitalGpSubmission => ({
  ...submission,
  baseData: {
    ...submission.baseData,
    ...(utmAffLinkVersion === SECOND_UTM_AFFILIATE_LINK_VERSION && employeeId && {
      ProducerData_SKY: {
        producerUtmID: employeeId,
        salesChannel: salesChannel ?? DEFAULT_SALES_CHANNEL,
      },
    }),
  },
});
